import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function TheStore() {
  return <section id="tienda" className="py-14 bg-cream-100" data-id="element-296">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-297">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto" data-id="element-298">
          <SparklesIcon className="h-10 w-10 text-olive-500 mx-auto mb-6" strokeWidth={1.5} data-id="element-299" />

          <h2 className="text-sm font-bold tracking-widest text-terracotta-500 uppercase mb-4" data-id="element-300">
            Presentando
          </h2>
          <h3 className="text-3xl md:text-5xl font-display text-charcoal mb-10" data-id="element-301">
            La tienda de blazers y camisas para mujer en Cali
          </h3>

          <div className="space-y-6 text-lg text-charcoal/80 font-light text-left md:text-center" data-id="element-302">
            <p data-id="element-303">
              En el corazón de Santa Mónica, Cali, existe un espacio creado
              específicamente para la mujer que ya sabe lo que quiere — y solo
              necesita encontrar las prendas que estén a su altura.
            </p>
            <p className="font-medium text-charcoal text-xl" data-id="element-304">
              No es una tienda más.
            </p>
            <p data-id="element-305">
              Es una curaduría de blazers y camisas diseñadas para la mujer real
              colombiana. Con cuerpo real. Con vida real. Con ambiciones reales.
            </p>

            <div className="py-8 my-8 border-y border-olive-200" data-id="element-306">
              <p className="text-sm uppercase tracking-widest text-olive-500 mb-4" data-id="element-307">
                Cada prenda fue elegida pensando en una sola pregunta:
              </p>
              <p className="text-2xl md:text-3xl font-display italic text-charcoal" data-id="element-308">
                "¿Esta prenda hace sentir a la mujer que la lleva más poderosa,
                más segura y más ella misma?"
              </p>
            </div>

            <p className="font-medium text-terracotta-500" data-id="element-309">
              Si la respuesta no era un rotundo sí — no entró al catálogo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}